import axios from "axios";
import { getToken, getTokenMember, logout } from "../utils/app.utils";

export const apiUrl = process.env.REACT_APP_BASE_API;
export const fileUrl = process.env.REACT_APP_FILE_BASE_API;

const refreshToken = async (refresh_token: string): Promise<string> => {
  try {
    // backend (ตาม Swagger) รับ key เป็น camelCase: { refreshToken }
    const res = await axios.post(`${apiUrl}/auth/refresh`, {
      refreshToken: refresh_token,
    });
    if (res.status < 300) {
      const new_access_token = res.data?.data?.access_token;
      const new_refresh_token = res.data?.data?.refresh_token;

      if (new_refresh_token) {
        localStorage.setItem("REFRESH_TOKEN", new_refresh_token);
      }
      if (new_access_token) {
        // เก็บที่ key เดียวกับตอน login ("TOKEN") ซึ่งทั้งระบบอ่านผ่าน getToken()
        // ไม่งั้น token ที่ refresh มาจะไม่ถูกใช้โดย component ที่เรียก getToken() ตรงๆ
        localStorage.setItem("TOKEN", new_access_token);
        return new_access_token;
      }
    }
    return "";
  } catch (err) {
    console.log("refreshToken error:", err);
    return "";
  }
};

const instance = axios.create({
  baseURL: apiUrl,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// ✅ ดึง token ทุกครั้งจาก localStorage
// ยกเว้น request ที่ set Authorization มาเองแล้ว (เช่น หน้า print ที่ส่ง token ผ่าน URL) — ห้ามทับ
instance.interceptors.request.use(
  async (config) => {
    const token = getToken() ?? getTokenMember();
    if (token && !config.headers["Authorization"]) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // ไม่มี session ใน localStorage (เช่น Puppeteer เปิดหน้า print ด้วย token จาก URL)
      // ไม่มีอะไรให้ logout — ห้าม redirect ไป /login ไม่งั้นหน้า print โดนเด้ง
      const hasSession = !!(
        getToken() ??
        getTokenMember() ??
        localStorage.getItem("REFRESH_TOKEN")
      );
      if (!hasSession) {
        return Promise.reject(error);
      }
      try {
        const refresh_token = localStorage.getItem("REFRESH_TOKEN");
        if (refresh_token) {
          const newToken = await refreshToken(refresh_token);
          if (newToken) {
            instance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            return instance(originalRequest);
          }
        }
        logout();
      } catch (err) {
        logout();
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default class BaseAPI {
  static api = instance;
}

export function setDefaultURL(url: any) {
  instance.defaults.baseURL = url;
}
